import { render, staticRenderFns } from "./DeliverableList.vue?vue&type=template&id=33e1b88f&scoped=true"
import script from "./DeliverableList.vue?vue&type=script&lang=js"
export * from "./DeliverableList.vue?vue&type=script&lang=js"
import style0 from "./DeliverableList.vue?vue&type=style&index=0&id=33e1b88f&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33e1b88f",
  null
  
)

export default component.exports